import {
  EnumGenericTaskStatus,
  EnumGenericTaskType,
  FilterFindManyGenericTaskInput
} from '@tools/ui/types/generated/graphql';
import { EnumBusyEntityCachedDataSourceType } from '@tools/ui/types/generated/graphql';

export const unmatchTasksNewQueryArgs: FilterFindManyGenericTaskInput = {
  type: EnumGenericTaskType.busyUnmatchTask,
  _operators: {
    status: {
      in: [EnumGenericTaskStatus.pending]
    }
  },
  busyFilter: {
    _operators: {
      sourceType: {
        in: [EnumBusyEntityCachedDataSourceType.UnlinkBusinessMatch]
      },
      createdAt: {
        gte: new Date(2024, 6, 1)
      }
    }
  }
};
